import domReady from "@wordpress/dom-ready";

domReady(() => {
	// Get all email and whatsapp containers
	const contactQasas = document.querySelector(
		".wp-block-qasas-companion-contact-qasas",
	);
	const emailContainers = document.querySelector(".email");
	const whatsappContainers = document.querySelector(".whatsapp");

	if (!contactQasas) return;

	contactQasas.addEventListener("mouseenter", function () {
		emailContainers.querySelector(".email-info").style.display = "none";
		whatsappContainers.querySelector(".whatsapp-info").style.display = "none";
	});

	// Handle email clicks
	emailContainers.addEventListener("click", function () {
		emailContainers.querySelector(".email-info").style.display = "inline";
		whatsappContainers.querySelector(".whatsapp-info").style.display = "none";
	});

	// Handle whatsapp clicks
	whatsappContainers.addEventListener("click", function () {
		whatsappContainers.querySelector(".whatsapp-info").style.display = "inline";
		emailContainers.querySelector(".email-info").style.display = "none";
	});
});
